export const CENTRAL_NETWORK_DETAILS = '/central/network';
export const CENTRAL_SOLACE_DETAILS = '/central/solace';
export const CENTRAL_LOG_CONTROL = '/central/logs';
export const CENTRAL_DATABASE_DETAILS = '/central/database-details';
export const CENTRAL_FIX_SESSION_DETAILS = '/central/FIX';
export const CENTRAL_FIX_SESSION_BASE = '/central';
export const CENTRAL_SM_FEATURE = '/central/sm';
